import State from '../core/State';

export const setTranslations = (translations: Record<string, string>) => (state: State) => ({
  ...state,
  translations,
});
